<template>
  <v-container>
    <v-row dense>
      <div v-for="(v,i) in items" :key="i">
        <v-btn v-if="isEmpty(v.id)" @click="onClick(v.id)" small outlined color="primary" class="mx-1">
          {{ v.name }}
        </v-btn>
        <v-btn v-else @click="onClick(v.id)" small color="success" class="mx-1">{{ v.name }}</v-btn>
      </div>
      <r-item-state-dialog ref="r-item-state-dialog"/>
    </v-row>
  </v-container>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {ItemModel} from "@/modules/redactor/models/item/ItemModel";
import RItemStateDialog from "@/modules/redactor/views/item/r-item-state-dialog";


export default {
  name: "r-item-state-menu",
  components: {RItemStateDialog},
  props: {
    model: VueTypes.instanceOf(ItemModel).isRequired
  },
  data: () => ({
    items: [
      {id: 0, name: "Build"},
      {id: 1, name: "Mine"},
      {id: 2, name: "Harvest"},
      {id: 3, name: "Remove"},
      {id: 4, name: "Ready"},
    ]
  }),
  methods: {
    isEmpty(id) {
      switch (id) {
        case 0:
          return !this.model.scbuild;
        case 1:
          return !this.model.scmine;
        case 2:
          return !this.model.scharvest;
        case 3:
          return !this.model.scremove;
        case 4:
          return !this.model.scready;
      }
      return false;
    },
    onClick(id) {
      switch (id) {
        case 0: {
          let data = this.model.scbuild ? this.model.scbuild.clone() : null;
          this.$refs['r-item-state-dialog'].show(ViewRules.UPDATE, data).then(data => {
            this.model.scbuild = data;
          }).catch(() => {
          });
          break;
        }
        case 1: {
          let data = this.model.scmine ? this.model.scmine.clone() : null;
          this.$refs['r-item-state-dialog'].show(ViewRules.UPDATE, data).then(data => {
            this.model.scmine = data;
          }).catch(() => {
          });
          break;
        }
        case 2: {
          let data = this.model.scharvest ? this.model.scharvest.clone() : null;
          this.$refs['r-item-state-dialog'].show(ViewRules.UPDATE, data).then(data => {
            this.model.scharvest = data;
          }).catch(() => {
          });
          break;
        }
        case 3: {
          let data = this.model.scremove ? this.model.scremove.clone() : null;
          this.$refs['r-item-state-dialog'].show(ViewRules.UPDATE, data).then(data => {
            this.model.scremove = data;
          }).catch(() => {
          });
          break;
        }
        case 4: {
          let data = this.model.scready ? this.model.scready.clone() : null;
          this.$refs['r-item-state-dialog'].show(ViewRules.UPDATE, data).then(data => {
            this.model.scready = data;
          }).catch(() => {
          });
          break;
        }
      }
    },
  }
}

</script>